import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/trumpet.png'


const _withScopeId = n => (_pushScopeId("data-v-585cbec7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrap" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "createTime" }
const _hoisted_4 = { style: {"padding":"0 0.16rem 0.16rem 0.16rem","font-size":"0.28rem"} }
const _hoisted_5 = { style: {"color":"red"} }
const _hoisted_6 = { class: "box mark" }
const _hoisted_7 = { class: "high-light" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = {
  key: 1,
  style: {"text-align":"left","display":"inline-block","width":"50px"}
}
const _hoisted_10 = { key: 2 }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "space" }, null, -1))
const _hoisted_12 = { class: "tip" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "ranking" }, "区域毛利排行榜", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "row",
  style: { background: '#E5F6F4', fontWeight: 500 }
}, [
  /*#__PURE__*/_createElementVNode("div", null, "区域名称"),
  /*#__PURE__*/_createElementVNode("div", null, "总收入"),
  /*#__PURE__*/_createElementVNode("div", { class: "percentage" }, "毛利收入")
], -1))
const _hoisted_15 = { class: "mark" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { class: "ranking" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "row",
  style: { background: '#E5F6F4', fontWeight: 500 }
}, [
  /*#__PURE__*/_createElementVNode("div", null, "厅台名称"),
  /*#__PURE__*/_createElementVNode("div", null, "总收入"),
  /*#__PURE__*/_createElementVNode("div", { class: "percentage" }, "毛利收入")
], -1))
const _hoisted_19 = { class: "mark" }
const _hoisted_20 = { class: "percentage" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "ranking" }, "店员销售排行TOP10", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "row mark",
  style: { background: '#E5F6F4', fontWeight: 500 }
}, [
  /*#__PURE__*/_createElementVNode("div", { style: {
                  width: '100px',
                  flexGrow: 0,
                } }, " 销售姓名 "),
  /*#__PURE__*/_createElementVNode("div", { style: {
                  width: '100px',
                  flexGrow: 2,
                } }, " 所属厅台 "),
  /*#__PURE__*/_createElementVNode("div", { class: "percentage" }, "总收入"),
  /*#__PURE__*/_createElementVNode("div", { class: "percentage" }, "毛利收入")
], -1))
const _hoisted_23 = { class: "mark" }
const _hoisted_24 = { style: {
                    width: '100px',
                    flexGrow: 0,
                  } }
const _hoisted_25 = { style: {
                    width: '100px',
                    flexGrow: 2,
                  } }

import { ref, watch, onMounted, nextTick } from "vue";
import { useRoute } from "vue-router";
import { CellGroup, Cell, Tabs, Tab, Overlay, Loading, Empty, Icon } from "vant";
import { formatPercentage, numToMoney } from "@/utils";
import createWatermark from "@/utils/watermark";
import dayjs from "dayjs";

import request from "@/provide/fetch";


export default /*#__PURE__*/_defineComponent({
  __name: 'BusinessHallBJ1',
  setup(__props) {

const route = useRoute();
const active = ref(0);
const productOrderPayCountAsc = ref(false); // 产品-下单成功量升序

const visible = ref(false);
const pageData = ref<any>({});
let time = dayjs(route?.params.time as string).format("YYYY-MM-DD");
const getPageData = async () => {
  const res = await request({
    url: "/api/wx/bh/mobile-summary",
    method: "POST",
    data: {
      startDay: time,
      endDay: time,
      provinceName: "北京",
    },
    headers: {
      openId: sessionStorage.getItem("openid"),
    },
  });
  if (res.code === 200) {
    // showSuccessToast("保存成功！");
    pageData.value = res.data;
    visible.value = true;
    console.log(pageData.value);
  } else {
    // showFailToast(res.data);
  }
};
getPageData();

// 区域排行
const areaList = ref<any>([]);
const getProductsData = async () => {
  const res = await request({
    url: "/api/wx/bh/area-businessHall-mobile-top",
    method: "POST",
    data: {
      startDay: time,
      endDay: time,
      groupUnit: "area",
      province: "北京",
    },
    headers: {
      openId: sessionStorage.getItem("openid"),
    },
    // params: {
    //   openId: 'o7Gwj6b4bHVGwrEVKckufk8jjIh4',
    // },
  });
  if (res.code === 200) {
    // showSuccessToast("保存成功！");
    areaList.value = res.data;
    if (res.data?.[0]?.area) {
      handleClick(res.data[0].area, 0);
    }
  } else {
    // showFailToast(res.data);
  }
};
getProductsData();

// 选择区域
const selectedArea = ref("");
const businessHallList = ref<any[]>([]);
const handleClick = async (area: string, index: number) => {
  activeItem.value = index;
  selectedArea.value = area;
  const res = await request({
    url: "/api/wx/bh/area-businessHall-mobile-top",
    method: "POST",
    data: {
      startDay: time,
      endDay: time,
      groupUnit: "business_hall",
      area,
      province: "北京",
    },
    headers: {
      openId: sessionStorage.getItem("openid"),
    },
    // params: {
    //   openId: 'o7Gwj6b4bHVGwrEVKckufk8jjIh4',
    // },
  });
  if (res.code === 200) {
    // showSuccessToast("保存成功！");
    businessHallList.value = res.data;
  } else {
    // showFailToast(res.data);
  }
};

// 店员排行
const distributorLoading = ref(false);
const sellerList = ref<any>([]);
const getSellerList = async () => {
  distributorLoading.value = true;
  const res = await request({
    url: "/api/wx/bh/hall-mobile-sale-person/detail",
    method: "POST",
    data: {
      pageParam: {
        current: 1,
        size: 10,
      },
      searchOption: {
        startDay: time,
        endDay: time,
        statisticColumn: "salesMan",
        orderItem: {
          field: "grossProfit",
          asc: false,
        },
        salePerson: true,
        province: "北京",
        // groupUnit: sessionStorage.getItem("openid"),
      },
    },
    headers: {
      openId: sessionStorage.getItem("openid"),
    },
  });
  distributorLoading.value = false;
  if (res.code === 200) {
    // showSuccessToast("保存成功！");
    sellerList.value = res.data.records;
  } else {
    // showFailToast(res.data);
  }
};
getSellerList();

watch(productOrderPayCountAsc, () => {
  getProductsData();
});

const getUserInfo = async () => {
  return request({
    url: "/api/wx/user/getUserByOpenId",
    method: "GET",
    params: {
      openId: sessionStorage.getItem("openid"),
    },
  }).then((res) => {
    if (res.code === 200) {
      sessionStorage.setItem("name", res.data.name);
    }
  });
};
const activeItem = ref(0);
onMounted(() => {
  if (sessionStorage.getItem("name")) {
    createWatermark(sessionStorage.getItem("name"), "mark", "#fff");
  } else {
    getUserInfo().then(() => {
      createWatermark(sessionStorage.getItem("name"), "mark", "#fff");
    });
  }
});

const tabs = ref();
watch(visible, () => {
  nextTick(() => {
    tabs.value.resize();
  });
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", null, "生成时间： " + _toDisplayString(_unref(dayjs)(_unref(route).params.time as string).format("YYYY-MM-DD")), 1)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_unref(Icon), {
          size: "0.28rem",
          name: "warning-o",
          color: "red"
        }),
        _createTextVNode(" 下方数据均为业务在系统中上传的移动订单数据，最新的数据日期为"),
        _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(dayjs)(_unref(route).params.time as string).format("YYYY年MM月DD日")), 1)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_unref(CellGroup), null, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pageData.value, (item, index) => {
              return (_openBlock(), _createBlock(_unref(Cell), {
                title: item.name,
                size: 
              index === 0 || index === 2 || index === 3 ? 'large' : 'normal'
            ,
                class: _normalizeClass(index === 0 || index === 2 || index === 3 ? 'bold' : ''),
                "title-style": { width: '100px', flex: 'inherit' },
                border: index !== 3,
                key: index
              }, {
                value: _withCtx(() => [
                  _createElementVNode("div", _hoisted_7, [
                    (
                    item.name !== '当日终端总量' &&
                    item.name !== '新增号卡总量' &&
                    item.name !== '当日订单总量'
                  )
                      ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(item.type === "percentage"
                      ? _unref(formatPercentage)(item.value)
                      : _unref(numToMoney)(item.value)), 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(item.value), 1)),
                    (
                    item.name !== '当日终端总量' &&
                    item.name !== '新增号卡总量' &&
                    item.name !== '当日订单总量'
                  )
                      ? (_openBlock(), _createElementBlock("span", _hoisted_10, [
                          _createTextVNode(" （环比："),
                          _createElementVNode("span", {
                            style: _normalizeStyle({ color: item.percentage >= 0 ? 'red' : 'green' })
                          }, _toDisplayString(`${item.percentage >= 0 ? "+" : ""}${_unref(formatPercentage)(
                        item.percentage
                      )}`), 5)
                        ]))
                      : (_openBlock(), _createElementBlock("span", {
                          key: 3,
                          style: _normalizeStyle({
                    color: item.percentage >= 0 ? 'red' : 'green',
                  }),
                          class: "percentageValue"
                        }, "（环比：" + _toDisplayString(`${item.percentage >= 0 ? "+" : ""}${_unref(formatPercentage)(
                      item.percentage
                    )}`), 5)),
                    _createTextVNode("） ")
                  ])
                ]),
                _: 2
              }, 1032, ["title", "size", "class", "border"]))
            }), 128))
          ]),
          _: 1
        }),
        _hoisted_11,
        _createVNode(_unref(Tabs), {
          active: active.value,
          "onUpdate:active": _cache[0] || (_cache[0] = ($event: any) => ((active).value = $event)),
          ref_key: "tabs",
          ref: tabs
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(Tab), { title: "区域维度" }, {
              default: _withCtx(() => [
                _createElementVNode("p", _hoisted_12, [
                  _createElementVNode("img", {
                    style: _normalizeStyle({ width: '0.28rem' }),
                    src: _imports_0,
                    alt: ""
                  }, null, 4),
                  _createTextVNode(" 点击排行榜中某一区域名称，下方会联动展示该区域 下对应的所有厅台毛利排行榜 ")
                ]),
                _hoisted_13,
                _hoisted_14,
                (!areaList.value.length)
                  ? (_openBlock(), _createBlock(_unref(Empty), {
                      key: 0,
                      description: "暂无数据",
                      "image-size": "100"
                    }))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_15, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(areaList.value, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "row",
                      key: index
                    }, [
                      _createElementVNode("div", {
                        onClick: ($event: any) => (handleClick(item.area, index)),
                        class: _normalizeClass({ active: activeItem.value === index })
                      }, _toDisplayString(item.area), 11, _hoisted_16),
                      _createElementVNode("div", null, _toDisplayString(_unref(numToMoney)(item.totalRevenue)), 1),
                      _createElementVNode("div", null, _toDisplayString(_unref(numToMoney)(item.grossProfit)), 1)
                    ]))
                  }), 128))
                ]),
                _createElementVNode("p", _hoisted_17, _toDisplayString(selectedArea.value) + "各厅台的毛利排行榜", 1),
                _hoisted_18,
                (!businessHallList.value?.length)
                  ? (_openBlock(), _createBlock(_unref(Empty), {
                      key: 1,
                      description: "暂无数据",
                      "image-size": "100"
                    }))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_19, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(businessHallList.value, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "row",
                      style: { borderBottom: '1px solid #ebedf0' },
                      key: index
                    }, [
                      _createElementVNode("div", null, _toDisplayString(item.businessHall), 1),
                      _createElementVNode("div", null, _toDisplayString(_unref(numToMoney)(item.totalRevenue)), 1),
                      _createElementVNode("div", _hoisted_20, _toDisplayString(_unref(numToMoney)(item.grossProfit)), 1)
                    ]))
                  }), 128))
                ])
              ]),
              _: 1
            }),
            _createVNode(_unref(Tab), { title: "店员维度" }, {
              default: _withCtx(() => [
                _hoisted_21,
                _hoisted_22,
                (!sellerList.value.length)
                  ? (_openBlock(), _createBlock(_unref(Empty), {
                      key: 0,
                      description: "暂无数据",
                      "image-size": "100"
                    }))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_23, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sellerList.value, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "row",
                      key: index
                    }, [
                      _createElementVNode("div", _hoisted_24, _toDisplayString(item.sellerName), 1),
                      _createElementVNode("div", _hoisted_25, _toDisplayString(item.businessHall), 1),
                      _createElementVNode("div", null, _toDisplayString(_unref(numToMoney)(item.totalRevenue)), 1),
                      _createElementVNode("div", null, _toDisplayString(_unref(numToMoney)(item.grossProfit)), 1)
                    ]))
                  }), 128))
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["active"])
      ])
    ], 512), [
      [_vShow, visible.value]
    ]),
    _createVNode(_unref(Overlay), {
      class: "overlay",
      show: !visible.value
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(Loading), { type: "spinner" })
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}
}

})